<div class="aker-dark-theme" appUserManual [userManualKey]="'project-selector'">
  @if (projects$ | async; as projects) {
    <mat-form-field class="item-selector no-underline aker-dark-selector-theme" floatLabel="never">
      @if (!(selectedProject$ | async)) {
        <mat-label>Select project</mat-label>
      }

      <mat-select
        class="my-selector"
        panelClass="project-select-panel"
        aria-label="Project selector"
        (selectionChange)="onSelectedProject($event.value, projects)"
        [value]="(selectedProject$ | async)?.id"
      >
        @for (project of projects; track project.id) {
          <mat-option [attr.aria-label]="project.name" [value]="project.id">
            {{ project.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
